import { V1_API_BASE_URL } from 'constants/urls'
import { fetchResource, postResource } from 'utils/fetchUtils'
import config from '../../../config'

export const getAll = () => fetchResource(`${V1_API_BASE_URL}/schools`)

export const getOne = schoolId =>
  fetchResource(`${V1_API_BASE_URL}/schools/${schoolId}`)

export const getAllFlyers = schoolId =>
  fetchResource(`${V1_API_BASE_URL}/schools/${schoolId}/flyers`)

export const getOneFlyer = (schoolId, flyerId) =>
  fetchResource(`${V1_API_BASE_URL}/schools/${schoolId}/flyers/${flyerId}`)

export const postOneFlyer = ({ body }) =>
  postResource(`${config.V2_API_HOST_NAME}/api/metrics/v2`, {
    body
  })



// WEBPACK FOOTER //
// ./src/shared/models/schools/index.js